import RestService, {ErrorDetails, ResponseStatus, RestCall} from "./restService";
import EnvironmentService from "./environmentService";
import {TransactionSummaryDto} from "../model/functionModels";

async function getMySummary(onSuccess: (a: TransactionSummaryDto) => Promise<any>,
                            onFailure: (a: string) => Promise<any>,
                            onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me/transactions/summary`,
            method: "get",
        } as RestCall,
        async (response: ResponseStatus) => {
            await onSuccess(response.body);
        },
        async (restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed getting summary!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

const SummaryService = {
    getMySummary,
};

export default SummaryService;

